module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_NL-308bebca69ac57f99352cfa6c29004e3.svg";